import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Layout } from './components/Layout';
import { useAuthSetup } from './auth/useAuthSetup';
import AuthGuard from './auth/AuthGuard';
import AdminRoute from './auth/AdminRoute';

// Admin Components
import { DeploymentGroupsList } from './components/admin/DeploymentGroupsList';
import { DeploymentGroupDetails } from './components/admin/DeploymentGroupDetails';
import { DeploymentGroupForm } from './components/admin/DeploymentGroupForm';
import PipelineSelection from './components/PipelineSelection';

// User Components
import { Dashboard } from './components/user/Dashboard';
import { PipelineDetails } from './components/user/PipelineDetails';

// Release Flow Components
import { ReleaseFlowListPage } from './pages/ReleaseFlowListPage';
import { ReleaseFlowEditorPage } from './pages/ReleaseFlowEditorPage';

// Release Management Components
import ReleaseListPage from './pages/ReleaseListPage';
import ReleaseFormPage from './pages/ReleaseFormPage';
import ReleaseViewPage from './pages/ReleaseViewPage';
import { ProductStacksPage } from './pages/ProductStacksPage';

function App() {
  // Set up authentication for API client
  useAuthSetup();

  return (
    <>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AuthGuard>
          <Layout>
            <Routes>
              {/* User Routes */}
              <Route path="/" element={<Dashboard />} />
              <Route path="/pipelines/:id" element={<PipelineDetails />} />
              
              {/* Release Flow Routes */}
              <Route path="/release-flows" element={<ReleaseFlowListPage />} />
              <Route path="/release-flows/new" element={<ReleaseFlowEditorPage />} />
              <Route path="/release-flows/:id" element={<ReleaseFlowEditorPage />} />
              <Route path="/release-flows/:id/edit" element={<ReleaseFlowEditorPage />} />
              
              {/* Release Management Routes */}
              <Route path="/releases" element={<ReleaseListPage />} />
              <Route path="/releases/create" element={<ReleaseFormPage />} />
              <Route path="/releases/:id" element={<ReleaseViewPage />} />
              <Route path="/releases/:id/edit" element={<ReleaseFormPage />} />

              {/* Product Stacks Routes (Admin only) */}
              <Route path="/product-stacks" element={<AdminRoute><ProductStacksPage /></AdminRoute>} />
              
              {/* Admin Routes */}
              <Route path="/admin/deployment-groups" element={<AdminRoute><DeploymentGroupsList /></AdminRoute>} />
              <Route path="/admin/deployment-groups/new" element={<AdminRoute><DeploymentGroupForm mode="create" /></AdminRoute>} />
              <Route path="/admin/deployment-groups/:id" element={<AdminRoute><DeploymentGroupDetails /></AdminRoute>} />
              <Route path="/admin/deployment-groups/:id/edit" element={<AdminRoute><DeploymentGroupForm mode="edit" /></AdminRoute>} />
              <Route path="/admin/deployment-groups/:id/select-pipelines" element={<AdminRoute><PipelineSelection /></AdminRoute>} />
              
              {/* Catch all route - redirect to dashboard */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </AuthGuard>
      </Router>
      
      {/* Global Toast Notifications */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            style: {
              background: '#22c55e',
            },
          },
          error: {
            duration: 5000,
            style: {
              background: '#ef4444',
            },
          },
        }}
      />
    </>
  );
}

export default App;